<template>
  <modal transition="pop-out" name="update-category" :width="550" :height="450">
    <div class="w-full">
      <form class="rounded px-8 pt-6 pb-8 mb-4" @submit.prevent>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Name
          </label>
          <input v-model="form.name" class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Category Name">
          <p v-if="errors.includes('name')" class="text-red-500 text-xs italic">Please provide a name.</p>
        </div>
        <div class="mb-1">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Description
          </label>
          <textarea v-model="form.description" class="appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Description...."></textarea>
          <p v-if="errors.includes('description')" class="text-red-500 text-xs italic">Please provide some description.</p>
        </div>
        <div class="mb-2">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Show On Homepage
          </label>
          <el-switch v-model="form.homepage_feature"></el-switch>
          <p v-if="false" class="text-red-500 text-xs italic">Please fill all fields.</p>
        </div>
        <div class="mb-6">
          <el-upload
            :action="upload_url"
            accept="image/jpeg, image.png">
            <el-button size="small">Choose category image</el-button>
          </el-upload>
        </div>
        <div class="flex items-center justify-between">
          <el-button @click="submit" type="primary" :loading="updating">Update</el-button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>

export default {
  name: 'CategoryUpdateForm',
  props: {
    upload_url: {
      type: String,
    },
  },
  data() {
    return {
      updating: false,
      update_image: false,
      errors: [],
    };
  },
  computed: {
    form() {
      return this.$store.state.InventoryModule.Catalog.currentSelected.category;
    },
  },
  methods: {
    async submit() {
      this.errors = [];
      // formValidation is a mixin in
      // src/Common/mixins/index.js
      this.errors = this.formValidation(this.form);

      // check for error length
      if (this.errors.length === 0) {
        try {
          this.updating = true;
          const formData = {
            name: this.form.name,
            description: this.form.description,
            homepage_feature: this.form.homepage_feature,
          };
          await this.$store.dispatch('InventoryModule/Catalog/updateCategory', { data: formData, categoryId: this.form.id });

          this.$modal.hide('update-category');
          this.$notify.success({
            title: 'Success',
            message: 'Category successfully updated',
          });
        } catch (e) {
          this.updating = false;
          if (e.errors) {
            this.$notify.error({
              title: 'Error',
              message: e.errors[0],
            });
            return false;
          }
          if (e.message) {
            this.$notify.error({
              title: 'Error',
              message: e.message,
            });
          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong',
            });
          }
        }

        this.updating = false;
      }
    },
  },
};
</script>

<style scoped>

</style>
